import AssignmentBadge from './view'

export default AssignmentBadge
